import { render } from "./FacetPanelExclustion.vue?vue&type=template&id=a6e42efa&scoped=true&ts=true"
import script from "./FacetPanelExclustion.vue?vue&type=script&lang=ts"
export * from "./FacetPanelExclustion.vue?vue&type=script&lang=ts"

import "./FacetPanelExclustion.vue?vue&type=style&index=0&id=a6e42efa&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e42efa"]])

export default __exports__